import { create } from "zustand";

export const useAuthStore = create((set) => ({
  user:
    typeof window !== "undefined" ? localStorage.getItem("userToken") : null,
  userDetails:
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("userInfo") || "null")
      : null,
  login: (res) => {
    if (res?.data?.data.token) {
      localStorage.setItem("userToken", res.data.data.token);
      localStorage.setItem("userInfo", JSON.stringify(res.data.data.user));
      set({
        user: res.data.data.token,
        userDetails: res.data.data.user,
      });
    }
  },
  logOut: () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("userInfo");
    set({ user: null, userDetails: null });
  },
}));
